import React, { useEffect, useState } from "react";
import { DailyDiary } from "src/shared/types/src";
import LocalImages from '../../../../static';
import BaseCard from "src/app/components/commonComponents/BaseCard";
import DailyDiaryDetails from "src/app/components/commonComponents/DailyDiaryDetails";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "src/app/navigation/routes";
import { dateFormatter } from "src/shared/utils/src";
import { DATE_FORMATS } from "src/shared/config/src";
// import BaseCard from "../commonComponents/BaseCard";
// import DailyDiaryDetails from "../commonComponents/DailyDiaryDetails";


const DailyDiaryCard = ({ details, timestamp }: { details: DailyDiary, timestamp: string }) => {

    const navigate = useNavigate();
    const [hasData, setHasData] = useState<boolean>(false);

    useEffect(() => {
        setHasData(
            hasDailyDiaryData()
        )
    }, [details]);
    
    const hasDailyDiaryData = () => {
        if (!details) return false;
        const { bottleLogs, meals, media, nappies, notes, sleepTimes, sunCream, toileting } = details;
    
        return (
            bottleLogs?.logs?.length > 0 ||
            meals?.items?.length > 0 ||
            media?.length > 0 ||
            nappies?.logs?.length > 0 ||
            notes?.fromParents ||
            notes?.toParents ||
            sleepTimes?.logs?.length > 0 ||
            sunCream?.logs?.length > 0 ||
            toileting?.logs?.length > 0
        );
    };

    const navigateToDailyDiaryDetailScreen = () => {
        if (!hasData) return;
        const date = dateFormatter(timestamp, DATE_FORMATS.YMD);
        navigate(AppRoutes.DAILY_DIARY_DETAILS_SCREEN(date), { state: { dailyDiaryDetails: details } })
    }
    
    return (
        <>
            <BaseCard customBaseCardStyle="mg-t-15" clickable={hasData} onPressFunc={navigateToDailyDiaryDetailScreen}>
                {
                    !hasData ? 
                    <>
                    <div className="d-flex align-items-center">  
                        <div className="section-with-img flex-1 pd-r-15">
                            <div className="section-img"><img src={LocalImages.dailyDiaryIcon} alt="daily diary icon"/></div>
                            <div className="fs-12 fw-semibold text-black flex-1 pd-l-10">Daily Diary</div>
                        </div>
                    </div>
                    <div className="mg-t-13 fs-12 text-black">No data available</div>

                    </>
                    : 
                    <DailyDiaryDetails details={details} />
                }
            </BaseCard>
        </>
    )
}

export default DailyDiaryCard;